export default "__VITE_ASSET__1BihAjM8__"